import script from "./activity-log.vue?vue&type=script&setup=true&lang=js"
export * from "./activity-log.vue?vue&type=script&setup=true&lang=js"

import "./activity-log.vue?vue&type=style&index=0&id=bb929964&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb929964"]])

export default __exports__